/**
 * WordPress記事の記事情報・記事タイトルを表現するview model.
 */
export default class UserProfileViewModel {
    /**
     * @param data APIから受け取った記事情報Data
     */
    constructor(data) {
        this.articleData = data
        this.articleTitle = data.title.rendered
        this.articleTags = this.getArticleTags(data)
    }

    getArticleTags(data) {
        const terms = data._embedded?.['wp:term']
        if (!Array.isArray(terms)) return []
        // categoryとpost_tagが2重配列で入ってくる
        return terms.flat()
            .filter(term => term.taxonomy === 'post_tag')
            .map(term => term.slug)
    }
}
